/** Round a currency amount to cents, half up. */
export function roundMoney(value: number): number {
  // toPrecision(15) drops the binary noise that stores 532.5 as 532.4999999999999.
  return Math.round(Number((value * 100).toPrecision(15))) / 100;
}
